module.exports = __webpack_public_path__ + "img/fjjt3.95a17e7a.png";